import { render, staticRenderFns } from "./TaxFees.vue?vue&type=template&id=1c43ec39&scoped=true&"
import script from "./TaxFees.vue?vue&type=script&lang=ts&"
export * from "./TaxFees.vue?vue&type=script&lang=ts&"
import style0 from "./TaxFees.vue?vue&type=style&index=0&id=1c43ec39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c43ec39",
  null
  
)

export default component.exports